import { Flex } from '@chakra-ui/core'
import React, { memo } from 'react'
import SliderSwitch from 'components/CommonComponents/SliderSwitch'
import styled from '@emotion/styled'
import useLocaleText from 'components/useLocaleText'

export interface PersonalViewFiltersState {
  contentType: string
  status: string
}

interface PersonalViewFiltersProps {
  isPersonalView: boolean
  onViewChange: (isPersonal: boolean) => void
  isDisabled?: boolean
  onFiltersChange?: (filters: PersonalViewFiltersState) => void
}

// // Types of content
// const contentTypes: SearchableMenuItem[] = [
//   { id: 'all', name: 'all_types', icon: <FileText size={16} /> },
//   { id: 'chat', name: 'chats', icon: <MessageCircle size={16} /> },
//   { id: 'task', name: 'tasks', icon: <ListTodo size={16} /> },
//   { id: 'post', name: 'posts', icon: <FileText size={16} /> },
// ]

// // Statuses
// const statusOptions: SearchableMenuItem[] = [
//   { id: 'all', name: 'all_statuses', bulletColor: '#718096' },
//   { id: 'not_completed', name: 'not_completed', bulletColor: '#ED8936' },
//   { id: 'completed', name: 'completed', bulletColor: '#48BB78' },
// ]

const FiltersWrapper = styled(Flex)`
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  padding-left: 16px;
  padding-right: 16px;
`

export const PersonalViewFilters = memo(
  ({ isPersonalView, onViewChange, isDisabled = false }: PersonalViewFiltersProps) => {
    // const [selectedContentType, setSelectedContentType] = useState<string>('all')
    // const [selectedStatus, setSelectedStatus] = useState<string>('all')

    const feed_header = useLocaleText('feed_header')
    const personal_header = useLocaleText('ai_header')

    // const handleContentTypeSelect = (item: SearchableMenuItem) => {
    //   const newType = item.id as string
    //   setSelectedContentType(newType)
    //   onFiltersChange?.({ contentType: newType, status: selectedStatus })
    // }

    // const handleStatusSelect = (item: SearchableMenuItem) => {
    //   const newStatus = item.id as string
    //   setSelectedStatus(newStatus)
    //   onFiltersChange?.({ contentType: selectedContentType, status: newStatus })
    // }

    // const handleClearContentType = () => {
    //   setSelectedContentType('all')
    //   onFiltersChange?.({ contentType: 'all', status: selectedStatus })
    // }

    // const handleClearStatus = () => {
    //   setSelectedStatus('all')
    //   onFiltersChange?.({ contentType: selectedContentType, status: 'all' })
    // }

    return (
      <FiltersWrapper
        alignItems="center"
        w="100%"
        justifyContent="space-between"
        style={{ columnGap: '10px' }}
        py="10px"
        px={8}
        position="relative"
      >
        <SliderSwitch
          isChecked={isPersonalView}
          onChange={onViewChange}
          inactiveLabel={feed_header}
          activeLabel={personal_header}
          isEdit={isDisabled}
        />
        {/* <Flex style={{ columnGap: '10px' }}>
          <Box w="200px">
            <SearchableMenu
              items={contentTypes}
              selectedId={selectedContentType}
              placeholder="select_content_type"
              onSelect={handleContentTypeSelect}
              onClear={handleClearContentType}
              isShowSearch={false}
              isShowClearButton={selectedContentType !== 'all'}
              isDisabled={isDisabled}
              isLocalTranslation={true}
              buttonProps={{
                borderRadius: '20px',
              }}
            />
          </Box>

          <Box w="200px">
            <SearchableMenu
              items={statusOptions}
              selectedId={selectedStatus}
              placeholder="select_status"
              onSelect={handleStatusSelect}
              onClear={handleClearStatus}
              isShowSearch={false}
              isShowClearButton={selectedStatus !== 'all'}
              isDisabled={isDisabled}
              isLocalTranslation={true}
              buttonProps={{
                borderRadius: '20px',
              }}
            />
          </Box>
        </Flex> */}
      </FiltersWrapper>
    )
  }
)
